// extracted by mini-css-extract-plugin
export default {"root":"api_keys_page_root__EY9og","createButton":"api_keys_page_createButton__HumlV"};